export enum ScriptStatus {
  LOADING = 'loading',
  IDLE = 'idle',
  READY = 'ready',
  ERROR = 'error',
}
